import LabelWithInput from "@components/input/LabelWithInput";
import React, { useEffect, useState } from "react";
import CustomTextInput from "@components/input/CustomTextInput";
import BasicButton from "@components/button/BasicButton";
import { useFormContext } from "react-hook-form";
import styled from "@emotion/styled";
import { useApiRequest } from "@utils/ApiRequest";
import { useMutation, useQuery } from "@tanstack/react-query";
import useUserInfoStore from "@store/useUserInfoStore";
import { Flex } from "antd";
import { useTranslation } from "react-i18next";

export const InputWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  width: "100%",
});

const TextBox = styled.div({
  display: "flex",
  flexDirection: "column",
  width: "100%",
});

const ErrorMessage = styled.div(({ theme }) => ({
  color: theme.color.light_gray,
  fontSize: "1.2rem",
  marginTop: "0.6rem",
  height: "1.5rem",
}));

export const Nickname = () => {
  const { setError, watch, setValue } = useFormContext();

  const { getNicknameCheck } = useApiRequest();
  const { t } = useTranslation();
  const { userInfo } = useUserInfoStore();
  const currentNickname = userInfo?.nickname;
  const isNicknameChanged = watch("nickname") !== currentNickname;

  const { mutate: checkNickname, isSuccess } = useMutation({
    mutationFn: getNicknameCheck,
    mutationKey: ["nicknameCheck"],
    // 중복이면 true
    onSuccess: (data) => {
      if (data) {
        setValue("isNicknameUnique", false);
        setError("nickname", {
          type: "manual",
          message: "중복된 닉네임입니다.",
        });
      } else {
        setValue("isNicknameUnique", true);
      }
    },
  });

  // 닉네임 중복 확인 상태
  const success = watch("isNicknameUnique") && isSuccess;

  useEffect(() => {
    if (!isNicknameChanged) {
      setValue("isNicknameUnique", true);
    } else {
      // 닉네임이 수정되면 success 상태를 false로 초기화
      setValue("isNicknameUnique", false);
    }
  }, [currentNickname, setValue, isNicknameChanged]);

  // 닉네임 중복 확인
  const handleCheckDuplicateNickname = async (nickname: string) => {
    checkNickname(nickname);
  };

  const handleChange = (e: any) => {
    const value = e.target.value;
    const filteredValue = value.replace(
      /[!~@#$%^&*()_+\s-{}[\]|:<>?\\/;\\'",.=`₩]/g,
      "",
    );
    e.target.value = filteredValue;
  };

  return (
    <LabelWithInput label={"닉네임"} required={true}>
      <InputWrapper>
        <TextBox>
          <CustomTextInput
            placeholder="닉네임 입력 (최대 10자)"
            name="nickname"
            success={success}
            message={success ? "사용 가능한 닉네임입니다." : undefined}
            isLoginPage={false}
            max={10}
            onInput={handleChange}
            fontSize="1.6rem"
          />
          <ErrorMessage>
            {t("닉네임 중복확인 후 저장 가능합니다.")}
          </ErrorMessage>
        </TextBox>
        <BasicButton
          onClick={() => handleCheckDuplicateNickname(watch("nickname"))}
          title="중복확인"
          disabled={watch("nickname") === currentNickname}
          height="5.2rem"
          padding="1.6rem 1.2rem"
          width="100%"
        />
      </InputWrapper>
    </LabelWithInput>
  );
};
